import { useQuery } from "react-query";
import axios from "axios";

interface UseFetchBitcoinPriceResponse {
  data: any;
  loading: boolean;
}

export const useFetchBitcoinPrice = (
  base: string
): UseFetchBitcoinPriceResponse => {
  const fetchBitcoinPrice = async (key: string) => {
    try {
      const res = await axios.get(`/market_price?base=${base}`);
      return res.data;
    } catch (err) {
      return;
    }
  };
  const { data, isLoading } = useQuery("market_price", fetchBitcoinPrice, {
    refetchOnMount: true,
  });

  return {
    data,
    loading: isLoading,
  };
};
